import { FiSearch } from "react-icons/fi";

export const SearchBar = ({ value, onChange }) => (
  <div className="w-full lg:max-w-md">
    <div className="relative w-full">
      <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
      <input
        className="pl-10 pr-4 h-11 w-full rounded-lg border border-slate-600
                   bg-transparent text-white placeholder:text-gray-400
                   focus:outline-none focus:ring-1 focus:ring-slate-500 text-sm"
        placeholder="Find"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  </div>
);
